import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARCollectiveInvoiceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/CollectiveInvoice/CollectiveInvoiceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARCollectiveInvoice"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARCollectiveInvoice"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARCollectiveInvoiceActivity)
